/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle, Polyline } from 'react-native-svg';

import { IconProps } from '../lib';

function RedditLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M240,104a24.00125,24.00125,0,0,0-43.40918-14.11938l.001-.0022C178.28369,78.74831,154.28027,72,128,72S77.7168,78.74831,59.4082,89.87844l.001.0022A24.00186,24.00186,0,1,0,27.794,124.66848l-.00245-.00073A51.62014,51.62014,0,0,0,24,144c0,39.76441,46.5625,72,104,72s104-32.23559,104-72a51.62014,51.62014,0,0,0-3.7915-19.33227l-.002.00073A23.98866,23.98866,0,0,0,240,104Z"
        opacity={0.2}
      />
      <Circle
        cx={188}
        cy={32.00002}
        r={16}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M161.026,176.00058a72.17425,72.17425,0,0,1-66.05159.0002"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="128 72 136 24 172.185 29.567"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Circle cx={88} cy={132} r={16} />
      <Circle cx={168} cy={132} r={16} />
    </Svg>
  );
}

export default RedditLogo;
